// TODO: Double check which flags:
//   1) are used from LD
//   2) used as non-LD flags
//   3) are not used
export const flags = {
  ADD_ZONE_TO_PORTAL_EVENTS: 'addZoneToPortalEvents',
  ADD_MEDIA: 'clubToolsAddMedia',
  CMS_EVENT_LISTING: 'clubToolsCmsEventListing',
  CMS_FIELDS_ON_EVENT_CREATION_EDITING:
    'clubToolsCmsFieldsOnEventCreationEditing',
  CMS_SITE_VISIBILITY: 'clubToolsCmsSiteVisibility',
  DEBUGGER: 'clubToolsDebugger',
  ENABLE_FLASH_MARKETPLACE: 'clubToolsEnableFlashMarketplace',
  NEW_DATE_WIDGET_FE: 'clubToolsNewDateWidgetFe',
  OFFER_LISTINGS: 'clubToolsOfferListings',
  ONSALE_DATE: 'clubToolsOnsaleDate',
  PRICE_CHART_UX_ENHANCEMENT: 'clubToolsPriceChartUxEnhancements',
  PRINT_TEMPLATE_SELECTION: 'clubToolsPrintTemplateSelection',
  RELATIVE_DATES_FE: 'clubToolsRelativeDatesFe',
  TICKET_TEXT_ON_ZONES: 'clubToolsTicketTextOnZones',
  CALCULATE_PRICE_COMPONENT_BY_PERCENTAGE:
    'calculate-price-component-by-percentage',
  LOGGER: 'clubToolsLogger',
  Enable_Offer_Auto_Publish_Feature: 'temp-offer-auto-publish-enabled',
  Enable_Promoters_Feature: 'promoter-features-enabled',
  ENABLE_SHORT_CODES: 'enable-short-codes',
  LISTING_EXPIRATION_DATE: 'listing-expiration-date',
  ENABLE_AXS_INVITE: 'enableAxsInvite',
  USE_UPDATED_POPUP_NOTIFICATION: 'useUpdatedPopupNotificationField',
};



// WEBPACK FOOTER //
// ./src/common/constants/flags.js